"use client";
import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { pushGtmEvent } from "@/utils/google-tag-manager";
import { GtmEvents, GtmProperties } from "@/constants/google-tag-manager";
import { Box } from "../atoms/Box";
import { Inter } from "next/font/google";
import classNames from "classnames";
import { trackAlsoFeaturedInClick } from "@/utils/mixpanel";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });
const DEV_URL = "https://devweb.atly.com";
const PROD_URL = "https://web.atly.com";

const OriginLink = ({ children, id, isMobile, position, pageTitle }) => {
    const [link, setLink] = useState("");
    
    useEffect(() => {
        if (typeof window !== "undefined") {
            if (
                window.location.origin.includes("web.atly.com") ||
                window.location.origin.includes("www.atly.com")
            ) {
                setLink(`${window.location.origin.replace("www", "web")}/t/${id}`);
            } else if (window.location.origin.includes("newtoptenbest.atly.com")) {
                setLink(`${PROD_URL}/t/${id}`);
            } else {
                setLink(`${DEV_URL}/t/${id}`);
            }
        }
    }, [id]);
    
    return (
        <div
            onClick={() => trackItemTapped(MixpanelValues.ItemTapped.ALSO_FEATURED_IN)}
            className={classNames(
                inter.className,
                "flex gap-3 text-blue-600 md:text-lg font-medium leading-relaxed underline"
            )}>
            <Link
                href={link}
                passHref
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                    trackAlsoFeaturedInClick();
                    pushGtmEvent(GtmEvents.CLICK_ALSO_FEATURED, {
                        [GtmProperties.GfeTopTen.PAGE_NAME]: pageTitle,
                        [GtmProperties.GfeTopTen.POSITION]: position,
                        [GtmProperties.GfeTopTen.ELEMENT_TEXT]: children.toString(),
                        [GtmProperties.GfeTopTen.DEVICE]: isMobile ? "mobile" : "desktop",
                    });
                }}>
                <span>{children}</span>
            </Link>
        </div>
    );
};

const getPossessiveForm = (name) => {
    if (!name) return "";
    const lastLetter = name[name.length - 1];
    return lastLetter === "s" ? `${name}'` : `${name}'s`;
};

const AlsoFeaturedInLink = ({ text, id, isMobile, position, pageTitle }) => {
    const linkText = useMemo(() => {
        const splitBasedOn = text.includes(" in ") ? " in " : " Across ";
        const splitText = text.replace(" - Atly", "").split(splitBasedOn);
        return `${getPossessiveForm(splitText[1])} ${splitText[0].replace(
            "Top",
            "best"
        )}`;
    }, [text]);
    
    return (
        <OriginLink
            id={id}
            isMobile={isMobile}
            position={position}
            pageTitle={pageTitle}>
            {linkText}
        </OriginLink>
    );
};

export const GlutenFreeAlsoFeaturedIn = ({
    data,
    isMobile,
    position,
    pageTitle,
}) => {
    if (data.length === 0) return null;
    
    return (
        <Box>
            <div>
                <div className={classNames(inter.className, "font-bold mb-2")}>
                    Also featured in
                </div>
                <div className="flex flex-col gap-2">
                    {data.slice(0, 3).map((item, index) => {
                        return (
                            <AlsoFeaturedInLink
                                key={index}
                                id={item._id}
                                text={item.title}
                                isMobile={isMobile}
                                position={position}
                                pageTitle={pageTitle}
                            />
                        );
                    })}
                </div>
            </div>
        </Box>
    );
};
